export const antiMnyLndCommLocation = "/reports/antimoneylaundering";
